import { render, staticRenderFns } from "./puzzle-difficult.vue?vue&type=template&id=d8369160&scoped=true"
import script from "./puzzle-difficult.vue?vue&type=script&lang=js"
export * from "./puzzle-difficult.vue?vue&type=script&lang=js"
import style0 from "./puzzle-difficult.vue?vue&type=style&index=0&id=d8369160&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d8369160",
  null
  
)

export default component.exports